// TODO: Refactor later, remove unecessary codes and separate blocks into components
/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { get, getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
// import ConfirmAlert from "modules/common/components/ConfirmAlert";
// import InputMask from 'react-input-mask';
import CmsContext from 'context/CmsContext';
// import Select from 'react-select';
import { reactSelectCustomStyleCms } from 'helper';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import * as actions from '../actions';
import * as c from '../constant';

import { InputTemplate } from "../../../common/components/inputComponents";
import AddressGroupComponent from "../../../common/address/AddressGroupComponent";

const AddRecordModalV2 = ({
  permissions,
  createRecordManualImport,
  getListManualImport,
  history,
  creating,
  type,
  updateRecordManualImport,
  dataInfo,
  dataInclude,
  id,
}) => {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  // const CMS_MASKINGS = cmsContext.findByType('MASKINGS');

    const [formData, setFormData] = useState({
    ...c.INITIAL_FORMDATA,
    location_region: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING") || "",
    location_province: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING") || "",
    location_municipality: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_MUNICIPALITY_FOR_ADDRESS_BILLING") || "",
  });

  // co-owners field
  const [coOwnersData, setCoOwnersData] = useState(c.CO_OWNER_FORMDATA);
  // const [coOwnersUpdate, setCoOwnersUpdate] = useState({});

  // amount field
  // const [amountFormData, setAmountFormData] = useState(c.AMOUNT_FORMDATA);
  // const [amountFormUpdate, setAmountFormUpdate] = useState({});

  const [tab, setTab] = useState(0)
  const setModal = useContext(ModalContext);
  const [pinFormat, setPinFormat] = useState(false);
  const isStatusPaid = _.get(dataInfo, "payment_status")?.toUpperCase()?.includes("PAID") || false
  // const getCurrentYear = () => `${new Date().getFullYear()}`;

  // const getYearsList = (start = getCurrentYear(), endOffset = 50) => {
  //   let y = [];
  //   for (let i = start; i > start - endOffset; i -= 1) {
  //     y = y.concat([
  //       {
  //         label: `${i}`,
  //         value: i,
  //       },
  //     ]);
  //   }
  //   return y;
  // };

  let commonValidation = {
    // tdn: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_TDN_REGEX_CSV')}~${_.get(
    //   CMS_MASKINGS,
    //   'RPTAX_TDN_CSV'
    // )}`,
    // pin: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_PIN_REGEX_CSV')}~${_.get(
      //   CMS_MASKINGS,
      //   'RPTAX_PIN_CSV'
      // )}`,
    // year: 'required',
    // account_number: `required|mask:${_.get(
    //   CMS_MASKINGS,
    //   'RPTAX_TDN_REGEX_CSV'
    // )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
    tdn: 'required',
    pin: 'required',
    // account_number: 'required',
    account_name: 'required',
    period_covered_from: 'required',
    // period_covered_to: 'required',
    year: 'required',
    owner_name: 'required',
    // co_owner_name: 'required',

    location_region: 'required',
    location_province: 'required',
    location_municipality: 'required',
    location_barangay: 'required',
    // location_district: 'required',
    location_zone: 'required',
    location_street: 'required',
    // 2nd page
    // area: 'required',
    // oct_tct_cloa_no: 'required',
    // survey_no: 'required',
    // lot_no: 'required',
    // block_no: 'required',
    kind_of_property: 'required',
    classification: 'required',
    // special_class: 'required',
    // boundaries_north: 'required',
    // boundaries_south: 'required',
    // boundaries_east: 'required',
    // boundaries_west: 'required',
    // first_quarter: 'required',
    // second_quarter: 'required',
    // third_quarter: 'required',
    // fourth_quarter: 'required',
    // fourth_quarter: 'required',

    // account_name: 'required',
    // date_processed: 'required',
    // expiration_date: 'required',
    // amount: 'required|amount',
  };

  // temporary disable for "MANUAL" imports
  // if (!_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT')) {
  //   commonValidation = {
  //     ...commonValidation,
  //     tdn: 'required|rptax_tdn',
  //     account_number: 'required|rptax_tdn',
  //   };
  // }

    const validateForm = useFormValidator(formData, commonValidation);
    const validateCoOwnersForm = useFormValidator(coOwnersData, {
      name: 'required',
    });

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onChangeBusinessAddress = (e) => {
    setFormData(prevForm => ({
      ...prevForm,
      location_region: _.get(e, "target.value.region_code"),
      location_province: _.get(e, "target.value.province_code"),
      location_municipality: _.get(e, "target.value.municipality_code"),
      location_barangay: _.get(e, "target.value.barangay_code"),
      location_street: _.get(e, "target.value.street"),
      location_zone: _.get(e, "target.value.zip_code"),
    }));
  };

  // temporary disable since 19 digit pin is disabled
  // useEffect(() => {
  //   if (pinFormat === false) {
  //     commonValidation = {
  //       ...commonValidation,
  //       account_number: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_TDN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
  //       tdn: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_TDN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
  //       pin: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_PIN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}`,
  //     };
  //     validateForm.onSetObjectRules(commonValidation);
  //   }
  //   if (pinFormat) {
  //     commonValidation = {
  //       ...commonValidation,
  //       account_number: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_TDN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
  //       tdn: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_TDN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
  //       pin: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_PIN_REGEX_2_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV')}`,
  //       pin: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_PIN_REGEX_2')}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}`
  //     };
  //     validateForm.onSetObjectRules(commonValidation);
  //   }
  // }, [pinFormat]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    validateCoOwnersForm.validate();
  }, [Object.values(coOwnersData).join(',')]);

  const handlePinFormat = e => {
    if (e.target.checked) {
      setPinFormat(true);
    } else {
      setPinFormat(false);
    }
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      period_covered_from: `${moment(_.get(formData, 'period_covered_from')).format(
        'YYYY-MM-DD'
      )}`,
    };

    if (!validateForm.response.is_passed) {
      if(tab === 0) {
          setTab(+tab+1)
      }
      if(tab === 1) {
          setTab(+tab+1)
      }
      // if(tab === ) {
      //     setTab(+tab+1)
      // }
      return false;
    }

    // temporarys add condition to only submit if in page 3 while other pages doesn't have data yet
    if (validateForm.response.is_passed) {
      if (tab === 0 && tab !== 2) {
          setTab(+tab+1)
      }

      if (!Acl(permissions, ['VIEW RPTAX ADD RECORDS ASSESSOR'])) {
        if (tab === 1 && tab !== 2) {
          setTab(+tab+1)
        }
      }

      if (tab === (!Acl(permissions, ['VIEW RPTAX ADD RECORDS ASSESSOR']) ? 2 : 1)) {
        // submit
        if (type === 'ADD') {
          createRecordManualImport(args, () => {
            setModal({ isOpen: false });
            getListManualImport({
              // overwrite_previous: 0,
              // is_active: 1,
            });
            history.push(`/billing/rptax`);
          });
        }
    
        if (type === 'EDIT') {
          updateRecordManualImport(id, args, () => {
            setModal({ isOpen: false });
            getListManualImport({
              overwrite_previous: 0,
              is_active: 1,
            });
            history.push(`/billing/rptax`);
          });
        }
      }
      return false;
    }

    return true
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
    if (key === 'year') {
      setFormData({
        ...formData,
        [key]: e ? e.value : '',
        mode_of_payment_1: `${e.value}-1`,
        mode_of_payment_2: `${e.value}-4`,
      });
    }
  };
  
  // const onChangeCoOwners = e => {
  //   e.preventDefault()
  //   setCoOwnersData({
  //     ...coOwnersData,
  //     name: e.target.value.toUpperCase(),
  //   });
  // };

  const onUpdateCoOwners = (id) => e => {
    e.preventDefault()
    // setCoOwnersUpdate({
    //   ...coOwnersUpdate,
    //   name: e.target.value.toUpperCase(),
    // });

    const updatedCoOwnerData = {
      name: e.target.value.toUpperCase(),
    }

    // for validation
    setCoOwnersData({
      ...coOwnersData,
      ...updatedCoOwnerData,
    });

    setFormData({
      ...formData,
      // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
      co_owners: [
        ...formData.co_owners.map((item, index) =>
          index === id ? updatedCoOwnerData : item
        ),
      ],
    });
  };

  const handleAddCoOwnersField = e => {
  e.preventDefault()

  setFormData({
    ...formData,
    // co_owners: [..._.get(formData, "co_owners"), coOwnersData],
    co_owners: [..._.get(formData, "co_owners"), {}],
  });

  setCoOwnersData({
    name: "",
  });

  // setFocus(false)
};

const handleDeleteCoOwnerField = (id) => {
  const arr = _.filter(
    _.get(formData, "co_owners"),
    (_item, index) => index !== id
  );

  setFormData({
    ...formData,
    co_owners: [...arr],
  });

  // setCoOwnersData({
  //   ...coOwnersData,
  //   name: '',
  // })

  // ConfirmAlert(
  //   <div>
  //     <p className='mb-0'>Are you sure you want to delete this Co-owner from the list?</p>
  //   </div>,
  //   () => {
  //     setFormData({
  //       ...formData,
  //       co_owners: [...arr],
  //     });
  //   },
  //   () => {},
  //   { yesLabel: "Confirm", noLabel: "Cancel", }
  // );
};

// for amount
// const onUpdateAmountData = (id) => e => {
//   e.preventDefault()
//   // setAmountFormData({
//   //   ...amountFormData,
//   //   name: e.target.value,
//   // });

//   // const updatedAmountFormData = {
//   //   [e.target.name]: e.target.value,
//   // }

//   setFormData({
//     ...formData,
//     // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
//     values: [
//       ...formData.values.map((item, index) =>
//         index === id ? {...item, [e.target.name]: +e.target.value,} : item
//       ),
//     ],
//   });
// };

  useEffect(() => {
    if (type === 'EDIT') {
      const splitStr = dataInfo.pin.replace(/\s+/g, '-').length;
      if (splitStr > 19) {
        setPinFormat(true);
      } else {
        setPinFormat(false);
      }
      setFormData({
        // tdn: dataInfo.tdn,
        // pin: dataInfo.pin,
        // year: dataInfo.year,
        // account_number: dataInfo.account_number,
        // account_name: dataInfo.account_name,
        // date_processed: moment(dataInfo.date_processed).format('MM-DD-YYYY'),
        // expiration_date: moment(dataInfo.expiration_date).format('MM-DD-YYYY'),
        // first_quarter:
        //   parseFloat(parseFloat(dataInfo.amount.replace(/,/g, ''))) *
        //   parseFloat(0.25),
        // second_quarter:
        //   parseFloat(parseFloat(dataInfo.amount.replace(/,/g, ''))) *
        //   parseFloat(0.5),
        // third_quarter:
        //   parseFloat(parseFloat(dataInfo.amount.replace(/,/g, ''))) *
        //   parseFloat(0.75),
        // fourth_quarter: parseFloat(dataInfo.amount.replace(/,/g, '')),
        // is_delinquent: dataInfo.is_delinquent,
        // is_overwrite: dataInfo.is_overwrite,
        // amount: parseFloat(dataInfo.amount.replace(/,/g, '')),
        // mode_of_payment_1: dataInfo.mode_of_payment_1,
        // mode_of_payment_2: dataInfo.mode_of_payment_2,

        tdn: dataInfo.tdn,
        pin: dataInfo.pin,
        account_number: dataInfo.account_number,
        account_name: dataInfo.account_name,
        // period_covered_from: dataInfo.period_covered_from, 
        // period_covered_to: dataInfo.period_covered_to,
        period_covered_from: `${moment(_.get(dataInfo, 'period_covered_from')).format('MM-DD-YYYY')}`,
        // period_covered_to: `${moment(_.get(dataInfo, 'period_covered_to')).format('MM-DD-YYYY')}`,
        year: dataInfo.year,
        owner_name: dataInfo.owner_name,
        location_region: dataInfo.location_region,
        location_province: dataInfo.location_province,
        location_municipality: dataInfo.location_municipality,
        location_barangay: dataInfo.location_barangay,
        location_district: dataInfo.location_district,
        location_zone: dataInfo.location_zone,
        location_street: dataInfo.location_street,
        area: dataInfo.area,
        oct_tct_cloa_no: dataInfo.oct_tct_cloa_no,
        survey_no: dataInfo.survey_no,
        lot_no: dataInfo.lot_no,
        block_no: dataInfo.block_no,
        kind_of_property: dataInfo.kind_of_property,
        classification: dataInfo.classification,
        special_class: dataInfo.special_class,
        boundaries_north: dataInfo.boundaries_north,
        boundaries_south: dataInfo.boundaries_south,
        boundaries_east: dataInfo.boundaries_east,
        boundaries_west: dataInfo.boundaries_west,
        first_quarter: dataInfo.first_quarter,
        second_quarter: dataInfo.second_quarter,
        third_quarter: dataInfo.third_quarter,
        fourth_quarter: dataInfo.fourth_quarter,
        total_amount: dataInfo.total_amount,
        co_owners: dataInclude?.coOwners.map(item => ({ name: item.attributes.name})) || [],
        values: !_.isEmpty(dataInclude?.values) ? dataInclude?.values.map(item => ({
          type: item.attributes.type,
          assessed_value: item.attributes.assessed_value,
          tax_due: item.attributes.tax_due,
          penalty: item.attributes.penalt,
          discount: item.attributes.discount,
          total_amount: item.attributes.total_amount,
        })) : [{
          type: '',
          assessed_value:  0,
          tax_due:  0,
          penalty:  0,
          discount:  0,
          total_amount:  0,
        },{ // duplicate key obj key for demo purpose only
          type: '',
          assessed_value:  0,
          tax_due:  0,
          penalty:  0,
          discount:  0,
          total_amount:  0,
        }],
      });
    }
  }, [dataInfo, dataInclude]);

  const MAX_VAL = 9999999999999999.99;
  const withValueCap = inputObj => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return true;
    return false;
  };


// stepper:
const paginateButton = () => {
  return (
    <div className="py-1"> 
      {tab !== (!Acl(permissions, ['VIEW RPTAX ADD RECORDS ASSESSOR']) ? 2 : 1) && (
        <div className="col-12 d-flex justify-content-center mt-3">
          {tab !== 0 && (
            <button
              type="button"
              onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
              className="btn btn-light button-cancel-2 mr-1"
              // temporary style
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Previous
            </button>
          )}
          {tab === 0 && (
            <button
              type="button"
              onClick={closeModal}
              className="btn btn-light button-cancel-2 mr-1"
              // temporary style
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Cancel
            </button>
          )}
          <button
            type="submit"
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
            // disabled={
            //   (tab === 0 && !validateForm.response.is_passed) ||
            //   (tab === 1 && !validateForm.response.is_passed) ||
            //   (tab === 2 && !validateForm.response.is_passed)
            // }
          >
            {/* <i className="fas fa-spinner fa-spin fa-lg" /> */}
            Next
          </button>
        </div>
      )}
      {tab === (!Acl(permissions, ['VIEW RPTAX ADD RECORDS ASSESSOR']) ? 2 : 1) && (
        <div className="col-12 d-flex justify-content-center mt-3">
          <button
            type="button"
            onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
            className="btn btn-link button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
          >
            Previous
          </button>
          <button
            disabled={(tab === (!Acl(permissions, ['VIEW RPTAX ADD RECORDS ASSESSOR']) ? 2 : 1) && !validateForm.response.is_passed )}
            type="submit"
            className={`btn btn-light button-proceed ml-1 cms-bg-color-primary ${isStatusPaid && "d-none"}`}
            style={{ color: '#fff' }}
          >
            {creating ? <i className="fas fa-spinner fa-spin fa-lg" /> : `Save`}
          </button>
        </div>
      )}
    </div>
  );
};

// const renderInputMaskConfigFromCMS = (isDefault, mask) => {
//   if(isDefault) return {}

//   return {
//     isInputMask: true,
//     maskChar: '',
//     mask,
//   }
// }

  return (
    <Modal.Body className="p-2">
      <form onSubmit={handleOnSubmit}>
        <div className="px-2">

          {/* 
            1st Page
            note: Move each page to a separate component
          */}
          {
            tab === 0 && (
              <>
                <div className="full-group-v2">
                  <div className="form-row">
                    <InputTemplate
                      // isInputMask
                      title="Tax Declaration Number (TDN)"
                      htmlFor="tdn"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("tdn")}
                      // Input component props
                      // placeholder="AA-00000-00000"
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="tdn"
                      name="tdn"
                      type="text"
                      // maskChar=""
                      // mask={_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}
                      // mask="999-999-999"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'tdn')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // isInputMask
                      title="Property Identification Number (PIN)"
                      htmlFor="pin"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("pin")}
                      // Input component props
                      // placeholder={pinFormat ? _.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV') : _.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="pin"
                      name="pin"
                      type="text"
                      // maskChar=""
                      // mask={pinFormat ? _.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV') : _.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}
                      // mask="999-999-999"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'pin')?.toUpperCase() || ''}
                      // 19 digit Format:
                      // withCheckBoxComponent={() => (
                      //   <div className="d-flex flex-row align-items-center justify-content-end">
                      //     {_.get(CMS_COMPONENTS, 'RPTAX_HAS_SECOND_FORMAT_TAGGING') === true && (
                      //       <>
                      //         <label className="full-label-v2 my-0 py-0">
                      //           {_.get(CMS_COMPONENTS, 'RPTAX_SECOND_FORMAT_TAGGING_LABEL')}
                      //         </label>
                      //         <input
                      //           className="ml-1 mb-0"
                      //           name="pinFormat"
                      //           type="checkbox"
                      //           checked={pinFormat}
                      //           onChange={handlePinFormat}
                      //         />
                      //       </>
                      //     )}
                      //   </div>
                      // )}
                    />
                    <InputTemplate
                      // {...renderInputMaskConfigFromCMS(!_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT'), _.get(CMS_MASKINGS, 'RPTAX_TDN_CSV'))}
                      title="Account Number / Owner ID"
                      htmlFor="account_number"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      // formValidatorMsg={validateForm.renderMessage("account_number")}
                      // Input component props
                      // placeholder={_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV') ? _.get(CMS_MASKINGS, 'RPTAX_TDN_CSV') : "AA-00000-00000"}
                      // placeholder="AA-00000-00000"
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="account_number"
                      name="account_number"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'account_number')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // title="Account Name"
                      title="Company / Corporation / Building Name"
                      htmlFor="account_name"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("account_name")}
                      // Input component props
                      placeholder="Company / Corporation / Building Name"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="account_name"
                      name="account_name"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'account_name')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // title="Billing Date"
                      title="Period Covered From"
                      htmlFor="period_covered_from"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("period_covered_from")}
                      withCustomInputComponent={() => (
                        <DateInputPicker
                          disabled={isStatusPaid}
                          inputClassName="full-input form-input-record-v2"
                          btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                          onChange={handleOnChangeDate('period_covered_from')}
                          placeholder="MM/DD/YYYY"
                          value={_.get(formData, 'period_covered_from') || ''}
                        />
                      )}
                    />
                    {/* <InputTemplate
                      // title="Expiration Date"
                      title="Period Covered To"
                      htmlFor="period_covered_to"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("period_covered_to")}
                      withCustomInputComponent={() => (
                        <DateInputPicker
                          inputClassName="full-input form-input-record-v2"
                          placeholder="MM/DD/YYYY"
                          btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                          onChange={handleOnChangeDate('period_covered_to')}
                          value={_.get(formData, 'period_covered_to') || ''}
                        />
                      )}
                    /> */}
                    <InputTemplate
                      title="Year"
                      htmlFor="year"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("year")}
                      withCustomInputComponent={() => (
                        <DateInputPicker
                          showYearPicker
                          disabled={isStatusPaid}
                          inputClassName="full-input form-input-record-v2"
                          placeholder="YYYY"
                          btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                          onChange={handleOnChangeDate('year')}
                          value={_.get(formData, 'year')?.toString() || ""}
                        />
                      )}
                    />
                    {/* <InputTemplate
                      title="SOA Amount"
                      htmlFor="amount"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("amount")}
                      withCustomInputComponent={() => (
                        <NumberFormat
                          name="amount"
                          id="amount"
                          placeholder="_"
                          // className="full-input-v2 text-uppercase my-2"
                          className="full-input-v2 my-2"
                          onValueChange={values => {
                            const { formattedValue, floatValue } = values;
                            const isDecimal =
                              floatValue && /^\d{1,}(\.\d{0,4})?$/.test(floatValue);
            
                            // SOA Amount computation
                            if (isDecimal) {
                              setFormData(prevFormData => ({
                                ...prevFormData,
                                amount: formattedValue || '',
                                first_quarter: parseFloat(floatValue) * parseFloat(0.25),
                                second_quarter: parseFloat(floatValue) * parseFloat(0.5),
                                third_quarter: parseFloat(floatValue) * parseFloat(0.75),
                                fourth_quarter: floatValue,
                              }));
                            }
                          }}
                          isAllowed={withValueCap}
                          isNumericString
                          thousandSeparator
                          allowNegative
                          allowLeadingZeros
                          displayType="input"
                          prefix=""
                          value={_.get(formData, 'amount', '') || ''}
                        />
                      )}
                    /> */}
                    {/* <InputTemplate
                      isSelect
                      title="Year"
                      htmlFor="year"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("year")}
                      // Input component props
                      placeholder="Select Year"
                      styles={reactSelectCustomStyleCms()}
                      disabled
                      // className="full-input text-uppercase"
                      className="full-input"
                      id="year"
                      name="year"
                      type="text"
                      options={getYearsList()}
                      onChange={handleOnChangeSelect('year')}
                      value={getYearsList().filter(item => `${item.value}` === `${_.get(formData, 'year') ? moment(_.get(formData, 'year')).format('YYYY') : '' }`)[0]}
                      components={{ IndicatorSeparator: () => null }}
                    /> */}
                  </div>
                </div>

                <div className="full-group-v2">
                 <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Owners</h3>
                  <div className="form-row">
                    <InputTemplate
                      title="Owner's Full Name"
                      htmlFor="owner_name"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("owner_name")}
                      // Input component props
                      placeholder="Full Name"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="owner_name"
                      name="owner_name"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'owner_name')?.toUpperCase() || ''}
                    />
                    {/* add co-owner lists here */}
                    {_.get(formData, 'co_owners')?.map((item, i) => {
                      return (
                        <InputTemplate
                          key={i}
                          title="Co-owners's Full Name"
                          // htmlFor={`${item}-${i}`}
                          htmlFor="name"
                          containerClassName="col-sm-12 col-md-6 col-lg-4"
                          // formValidatorMsg={_.isEmpty(_.get(item, 'name')) ? validateCoOwnersForm.renderMessage("name") : (<small className="fa fa-check text-success" style={{ fontSize: 10, padding: '1px' }}/>)}
                          formValidatorMsg={(type === "EDIT" && isStatusPaid) ? false : validateCoOwnersForm.renderMessage("name")}
                          // Input component props
                          placeholder="_"
                          // className="full-input-2 text-uppercase"
                          className="full-input-2"
                          disabled={isStatusPaid}
                          type="text"
                          // name={`${item}-${i}`}
                          // id={`${item}-${i}`}
                          name="name"
                          id="name"
                          // onChange={onChangeCoOwners}
                          onChange={onUpdateCoOwners(i)}
                          value={_.get(item, "name")?.toUpperCase() || ""}
                          // action button (undo)
                          actionButtonContainerClass="border"
                          withActionButton={() => {
                            return (
                              <button
                                type="button"
                                disabled={isStatusPaid}
                                className="btn no-btn px-2 border-none"
                                onClick={() => handleDeleteCoOwnerField(i)}
                              >
                                <i className="fas fa-trash-alt text-danger" style={{backgroundColor: 'none'}}></i>
                              </button>
                            )
                          }}
                        />
                      )
                    })}
                    {/* <InputTemplate
                      title="Co-owners's Full Name"
                      htmlFor="name"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      // formValidatorMsg={validateForm.renderMessage("name_full_name")}
                      // Input component props
                      placeholder="_"
                      // className="full-input-2 text-uppercase"
                      className="full-input-v2"
                      type="text"
                      name="name"
                      id="name"
                      onChange={onChangeCoOwners}
                      value={_.get(coOwnersData, "name")?.toUpperCase() || ""}
                      // action button (undo)
                      actionButtonContainerClass="border"
                      withActionButton={() => {
                        return (
                          <button
                            type="button"
                            className="btn no-btn px-2 border-none"
                            onClick={() => {}}
                          >
                            <i className="fas fa-trash-alt text-danger" style={{backgroundColor: 'none'}}></i>
                          </button>
                        )
                      }}
                    /> */}
                    
                    <div className="form-input-group-v2 my-1 col-sm-12 col-md-6 col-lg-4 d-flex align-items-end">
                      <button
                        type="button"
                        disabled={isStatusPaid}
                        onClick={handleAddCoOwnersField}
                        style={{ height: '43px' }}
                        className="btn btn-primary cms-bg-color-secondary cms-outline-secondary mr-2">
                        <i className="fa fa-plus mr-3" /> Add Co-Owner
                      </button>
                    </div>
                  </div>
                </div>
                <div className="full-group-v2">
                 <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Location</h3>
                  <div className="form-row">                    
                    <AddressGroupComponent
                      name=""
                      // isDisabled="region_code, province_code"
                      isDisabled={"region_code, province_code, municipality_code" || isStatusPaid}
                      region_name="location_region"
                      province_name="location_province"
                      municipality_name="location_municipality"
                      // district_name="location_district"
                      // zone_name="location_zone"
                      barangay_name="location_barangay"
                      street_name="location_street"
                      zip_code_name="location_zone"
                      onChange={onChangeBusinessAddress}
                      value={{
                        region_code: _.get(formData, "location_region") || "",
                        // region_code: "080000000" || "",
                        province_code: _.get(formData, "location_province") || "" ,
                        municipality_code: _.get(formData, "location_municipality") || "" ,
                        barangay_code: _.get(formData, "location_barangay") || "",
                        street: _.get(formData, "location_street") || "",
                        zip_code: _.get(formData, "location_zone") || "",
                      }}
                      // validatorMessage={validateForm.renderMessage}
                    />
                  </div>
                </div>
              </>
            )
          }
          {/* 2nd Page */}
          {
            tab === 1 && (
              <>
                <div className="full-group-v2">
                  <div className="form-row">
                    <InputTemplate
                      title="Area (in sqm)"
                      htmlFor="area"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("area")}
                      withCustomInputComponent={() => (
                        <NumberFormat
                          name="area"
                          id="area"
                          placeholder="0"
                          // className="full-input-v2 text-uppercase my-2"
                          className="full-input-v2"
                          onValueChange={values => {
                            const { floatValue } = values
                            setFormData(() => ({
                              ...formData,
                              area: floatValue
                            }));
                          }}
                          disabled={isStatusPaid}
                          isAllowed={withValueCap}
                          isNumericString
                          thousandSeparator
                          allowNegative
                          allowLeadingZeros
                          displayType="input"
                          prefix=""
                          value={_.get(formData, 'area', '') || ''}
                        />
                      )} 
                    />
                    <InputTemplate
                      // isInputMask
                      title="OCT / TCT / CLOA NO."
                      htmlFor="oct_tct_cloa_no"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("oct_tct_cloa_no")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      // mask="999-999-999"
                      id="oct_tct_cloa_no"
                      name="oct_tct_cloa_no"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'oct_tct_cloa_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // isInputMask
                      title="Survey No."
                      htmlFor="survey_no"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("survey_no")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      // mask="999-999-999"
                      id="survey_no"
                      name="survey_no"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'survey_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Lot No."
                      htmlFor="lot_no"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("lot_no")}
                      // Input component props
                      placeholder="Lot No."
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      mask="000-000-000"
                      id="lot_no"
                      name="lot_no"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'lot_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Block No."
                      htmlFor="block_no"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("block_no")}
                      // Input component props
                      placeholder="Block No."
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="block_no"
                      name="block_no"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'block_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      isSelect
                      title="Kind of Property"
                      htmlFor="kind_of_property"
                      containerClassName="col-sm-12 col-md-6"
                      formValidatorMsg={validateForm.renderMessage("kind_of_property")}
                      // Input component props
                      placeholder=""
                      styles={reactSelectCustomStyleCms()}
                      // className="full-input text-uppercase"
                      className="full-input"
                      isDisabled={isStatusPaid}
                      id="kind_of_property"
                      name="kind_of_property"
                      type="text"
                      onChange={handleOnChangeSelect('kind_of_property')}
                      options={c.PROPERTY_KINDS}
                      value={c.PROPERTY_KINDS.find((item) => _.get(formData, "kind_of_property") === _.get(item, "value")) || ""} // placeholdef value only
                      components={{ IndicatorSeparator: () => null }}
                    />
                    <InputTemplate
                      isSelect
                      title="Classification"
                      htmlFor="classification"
                      containerClassName="col-sm-12 col-md-6"
                      formValidatorMsg={validateForm.renderMessage("classification")}
                      // Input component props
                      placeholder=""
                      styles={reactSelectCustomStyleCms()}
                      // className="full-input text-uppercase"
                      className="full-input"
                      isDisabled={isStatusPaid}
                      id="classification"
                      name="classification"
                      type="text"
                      onChange={handleOnChangeSelect('classification')}
                      options={c.CLASSIFICATIONS}
                      value={c.CLASSIFICATIONS.find((item) => _.get(formData, "classification") === _.get(item, "value")) || ""} // placeholdef value only
                      components={{ IndicatorSeparator: () => null }}
                    />
                    <InputTemplate
                      title="Special Classes"
                      htmlFor="special_class"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("special_class")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="special_class"
                      name="special_class"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'special_class')?.toUpperCase() || ''}
                    />
                  </div>
                </div>
                <div className="full-group-v2">
                  <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Boundaries</h3>
                  <div className="form-row">
                    <InputTemplate
                      title="North"
                      htmlFor="boundaries_north"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("boundaries_north")}
                      // Input component props
                      placeholder="0"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="boundaries_north"
                      name="boundaries_north"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'boundaries_north')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="South"
                      htmlFor="boundaries_south"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("boundaries_south")}
                      // Input component props
                      placeholder="0"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="boundaries_south"
                      name="boundaries_south"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'boundaries_south')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="East"
                      htmlFor="boundaries_east"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("boundaries_east")}
                      // Input component props
                      placeholder="0"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="boundaries_east"
                      name="boundaries_east"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'boundaries_east')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="West"
                      htmlFor="boundaries_west"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("boundaries_west")}
                      // Input component props
                      placeholder="0"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid}
                      id="boundaries_west"
                      name="boundaries_west"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'boundaries_west')?.toUpperCase() || ''}
                    />
                  </div>
                </div>
              </>
            )
          }
          {/* 3rd Page */}
          {
             tab === 2 && (
              <>
                <div className="full-group-v2">
                  <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Amount</h3>
                    <div style={{ overflowX: 'scroll' }}>
                      {_.get(formData, "values")?.map((data, i) => {

                        return (
                          // note: Amount temporary hidden from modal
                          <div key={i} className="d-none"> 
                          {/* title */}
                            <div className="container-fluid mx-auto px-0" style={{ minWidth: '720px' }}>
                              <div className="mb-2 justify-content-center amount-container">
                                {/* <div className="d-none col-1 d-flex align-items-center justify-content-center p-2" /> */}
                                <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                                  <b className="text-center m-0 cms-text-primary ">Assessed Value</b>
                                </div>
                                <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                                  <b className="text-center m-0 cms-text-primary">
                                    Tax Due
                                  </b>
                                </div>
                                <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                                  <b className="text-center m-0 cms-text-primary">
                                    Penalty
                                  </b>
                                </div>
                                <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                                  <b className="text-center m-0 cms-text-primary">Discount</b>
                                </div>
                                <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                                  <b className="text-center m-0 cms-text-primary">
                                    Basic Total Amount
                                  </b>
                                </div>
                                {/* <div className="d-none col-1 d-flex align-items-center justify-content-center p-2" /> */}
                              </div>
                            </div>
                            {/* content */}
                            <div className="amount-container pt-2 pb-3 mt-1 justify-content-center border-bottom" style={{ maxHeight: "400px", minWidth: '720px' }}>
                              <div className="">
                                <InputTemplate
                                  containerClassName="mx-1"
                                  // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                  withCustomInputComponent={() => (
                                    <NumberFormat
                                      name="assessed_value"
                                      id="assessed_value"
                                      placeholder="0"
                                      // className="full-input-v2 text-uppercase my-2"
                                      className="full-input-v2"
                                      onValueChange={values => {
                                        const { floatValue } = values
                                        setFormData({
                                          ...formData,
                                          // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
                                          values: [
                                            ...formData.values.map((item, index) =>
                                              index === i ? {...item, assessed_value: floatValue} : item
                                            ),
                                          ],
                                        });
                                      }}
                                      isAllowed={withValueCap}
                                      isNumericString
                                      thousandSeparator
                                      allowNegative
                                      allowLeadingZeros
                                      displayType="input"
                                      prefix=""
                                      value={_.get(data, 'assessed_value', '') || ''}
                                    />
                                  )} 
                                />
                              </div>
                              <div className="">
                                <InputTemplate
                                  containerClassName="mx-1"
                                  // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                  withCustomInputComponent={() => (
                                    <NumberFormat
                                      name="tax_due"
                                      id="tax_due"
                                      placeholder="0"
                                      // className="full-input-v2 text-uppercase my-2"
                                      className="full-input-v2"
                                      onValueChange={values => {
                                        const { floatValue } = values
                                        setFormData({
                                          ...formData,
                                          // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
                                          values: [
                                            ...formData.values.map((item, index) =>
                                              index === i ? {...item, tax_due: floatValue} : item
                                            ),
                                          ],
                                        });
                                      }}
                                      isAllowed={withValueCap}
                                      isNumericString
                                      thousandSeparator
                                      allowNegative
                                      allowLeadingZeros
                                      displayType="input"
                                      prefix=""
                                      value={_.get(data, 'tax_due', '') || ''}
                                    />
                                  )} 
                                />
                              </div>
                              <div className="">
                                <InputTemplate
                                  containerClassName="mx-1"
                                  // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                  withCustomInputComponent={() => (
                                    <NumberFormat
                                      name="penalty"
                                      id="penalty"
                                      placeholder="0"
                                      // className="full-input-v2 text-uppercase my-2"
                                      className="full-input-v2"
                                      onValueChange={values => {
                                        const { floatValue } = values
                                        setFormData({
                                          ...formData,
                                          // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
                                          values: [
                                            ...formData.values.map((item, index) =>
                                              index === i ? {...item, penalty: floatValue} : item
                                            ),
                                          ],
                                        });
                                      }}
                                      isAllowed={withValueCap}
                                      isNumericString
                                      thousandSeparator
                                      allowNegative
                                      allowLeadingZeros
                                      displayType="input"
                                      prefix=""
                                      value={_.get(data, 'penalty', '') || ''}
                                    />
                                  )} 
                                />
                              </div>
                              <div className="">
                                <InputTemplate
                                  containerClassName="mx-1"
                                  // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                  withCustomInputComponent={() => (
                                    <NumberFormat
                                      name="discount"
                                      id="discount"
                                      placeholder="0"
                                      // className="full-input-v2 text-uppercase my-2"
                                      className="full-input-v2"
                                      onValueChange={values => {
                                        const { floatValue } = values
                                        setFormData({
                                          ...formData,
                                          // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
                                          values: [
                                            ...formData.values.map((item, index) =>
                                              index === i ? {...item, discount: floatValue} : item
                                            ),
                                          ],
                                        });
                                      }}
                                      isAllowed={withValueCap}
                                      isNumericString
                                      thousandSeparator
                                      allowNegative
                                      allowLeadingZeros
                                      displayType="input"
                                      prefix=""
                                      value={_.get(data, 'discount', '') || ''}
                                    />
                                  )} 
                                />
                              </div>
                              <div className="">
                                <InputTemplate
                                  containerClassName="mx-1"
                                  // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                  withCustomInputComponent={() => (
                                    <NumberFormat
                                      name="total_amount"
                                      id="total_amount"
                                      placeholder="0"
                                      // className="full-input-v2 text-uppercase my-2"
                                      className="full-input-v2"
                                      onValueChange={values => {
                                        const { floatValue } = values
                                        setFormData({
                                          ...formData,
                                          // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
                                          values: [
                                            ...formData.values.map((item, index) =>
                                              index === i ? {...item, total_amount: floatValue} : item
                                            ),
                                          ],
                                        });
                                      }}
                                      isAllowed={withValueCap}
                                      isNumericString
                                      thousandSeparator
                                      allowNegative
                                      allowLeadingZeros
                                      displayType="input"
                                      prefix=""
                                      value={_.get(data, 'total_amount', '') || ''}
                                    />
                                  )} 
                                />
                              </div>
                            </div>
                          </div>)
                        })
                      }

                      {/* grand total */}
                      <div className="mt-2 mb-4">
                        <div className="my-1 d-flex align-items-center justify-content-between rounded cms-bg-color-light" style={{ minWidth: '720px'}}>
                          <h4 className="pl-2 h4 font-weight-bolder span-title2 my-0">Total Taxed Amount</h4>
                          <div className="font-weight-bolder text-dark my-0">
                            {/* PHP {numberWithCommas(formData.first_quarter + formData.second_quarter + formData.third_quarter + formData.fourth_quarter) || '0.00'} */}
                            <InputTemplate
                              containerClassName="mx-2"
                              // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="total_amount"
                                  id="total_amount"
                                  placeholder="PHP 0.00"
                                  // className="full-input-v2 text-uppercase my-2"
                                  className="full-input-v2"
                                  style={{ minWidth: '450px'}}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    setFormData(() => ({
                                      ...formData,
                                      total_amount: floatValue,
                                      first_quarter: floatValue/4,
                                      second_quarter: floatValue/4,
                                      third_quarter: floatValue/4,
                                      fourth_quarter: floatValue/4,
                                    }));
                                  }}
                                  disabled={isStatusPaid}
                                  isAllowed={withValueCap}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix="PHP "
                                  value={_.get(formData, 'total_amount', '') || ''}
                                />
                              )} 
                            />
                          </div>
                        </div>
                        <div className="my-1 d-flex align-items-center justify-content-between rounded" style={{ minWidth: '720px'}}>
                          <h4 className="pl-2 h4 font-weight-bolder span-title2 my-0">Discount</h4>
                          <div className="font-weight-bolder text-dark my-0">
                            <InputTemplate
                              containerClassName="mx-2"
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="total_amount"
                                  id="total_amount"
                                  placeholder="PHP 0.00"
                                  className="full-input-v2"
                                  style={{ minWidth: '450px'}}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    setFormData(() => ({
                                      ...formData,
                                      total_amount: floatValue,
                                      first_quarter: floatValue/4,
                                      second_quarter: floatValue/4,
                                      third_quarter: floatValue/4,
                                      fourth_quarter: floatValue/4,
                                    }));
                                  }}
                                  disabled={isStatusPaid}
                                  isAllowed={withValueCap}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix="PHP "
                                  value={_.get(formData, 'total_amount', '') || ''}
                                />
                              )} 
                            />
                          </div>
                        </div>
                        <div className="my-1 d-flex align-items-center justify-content-between rounded cms-bg-color-light" style={{ minWidth: '720px'}}>
                          <h4 className="pl-2 h4 font-weight-bolder span-title2 my-0">Penalty</h4>
                          <div className="font-weight-bolder text-dark my-0">
                            <InputTemplate
                              containerClassName="mx-2"
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="total_amount"
                                  id="total_amount"
                                  placeholder="PHP 0.00"
                                  className="full-input-v2"
                                  style={{ minWidth: '450px'}}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    setFormData(() => ({
                                      ...formData,
                                      total_amount: floatValue,
                                      first_quarter: floatValue/4,
                                      second_quarter: floatValue/4,
                                      third_quarter: floatValue/4,
                                      fourth_quarter: floatValue/4,
                                    }));
                                  }}
                                  disabled={isStatusPaid}
                                  isAllowed={withValueCap}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix="PHP "
                                  value={_.get(formData, 'total_amount', '') || ''}
                                />
                              )} 
                            />
                          </div>
                        </div>
                      </div>
                      <div className="container-fluid mx-auto px-0" style={{ minWidth: '720px' }}>
                        <div className="mb-2 justify-content-center quarter-container">
                          <div className="d-flex align-items-center cms-bg-color-primary-light border-bottom p-2">
                            <b className=" m-0 cms-text-primary ">1st Quarter</b>
                          </div>
                          <div className="d-flex align-items-center cms-bg-color-primary-light border-bottom p-2">
                            <b className=" m-0 cms-text-primary">
                              2nd Quarter
                            </b>
                          </div>
                          <div className="d-flex align-items-center cms-bg-color-primary-light border-bottom p-2">
                            <b className=" m-0 cms-text-primary">
                              3rd Quarter
                            </b>
                          </div>
                          <div className="d-flex align-items-center cms-bg-color-primary-light border-bottom p-2">
                            <b className=" m-0 cms-text-primary">4th Quarter</b>
                          </div>
                          {/* <div className="d-none col-1 d-flex align-items-center justify-content-center p-2" /> */}
                        </div>
                      </div>

                      <div className="quarter-container pt-2 pb-3 mt-1 justify-content-center border-bottom" style={{ maxHeight: "400px", minWidth: '720px' }}>
                        <div className="">
                          <InputTemplate
                            containerClassName="mx-1"
                            // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                            withCustomInputComponent={() => (
                              <NumberFormat
                                name="first_quarter"
                                id="first_quarter"
                                placeholder="PHP 0.00"
                                // className="full-input-v2 text-uppercase my-2"
                                className="full-input-2"
                                onValueChange={values => {
                                  const { floatValue } = values
                                  setFormData(() => ({
                                    ...formData,
                                    first_quarter: floatValue
                                  }));
                                }}
                                isAllowed={withValueCap}
                                isNumericString
                                thousandSeparator
                                allowNegative
                                allowLeadingZeros
                                decimalScale={2}
                                displayType="text"
                                prefix="PHP "
                                value={_.get(formData, 'first_quarter', '') || '0'}
                              />
                            )} 
                          />
                        </div>
                        <div className="">
                          <InputTemplate
                            containerClassName="mx-1"
                            // formValidatorMsg={validateForm.renderMessage("second_quarter")}
                            withCustomInputComponent={() => (
                              <NumberFormat
                                name="second_quarter"
                                id="second_quarter"
                                placeholder="PHP 0.00"
                                // className="full-input-v2 text-uppercase my-2"
                                className="full-input-2"
                                onValueChange={values => {
                                  const { floatValue } = values
                                  setFormData(() => ({
                                    ...formData,
                                    second_quarter: floatValue
                                  }));
                                }}
                                isAllowed={withValueCap}
                                isNumericString
                                thousandSeparator
                                allowNegative
                                allowLeadingZeros
                                decimalScale={2}
                                displayType="text"
                                prefix="PHP "
                                value={_.get(formData, 'second_quarter', '') || '0'}
                              />
                            )} 
                          />
                        </div>
                        <div className="">
                          <InputTemplate
                            containerClassName="mx-1"
                            // formValidatorMsg={validateForm.renderMessage("third_quarter")}
                            withCustomInputComponent={() => (
                              <NumberFormat
                                name="third_quarter"
                                id="third_quarter"
                                placeholder="PHP 0.00"
                                // className="full-input-v2 text-uppercase my-2"
                                className="full-input-2"
                                onValueChange={values => {
                                  const { floatValue } = values
                                  setFormData(() => ({
                                    ...formData,
                                    third_quarter: floatValue
                                  }));
                                }}
                                isAllowed={withValueCap}
                                isNumericString
                                thousandSeparator
                                allowNegative
                                allowLeadingZeros
                                decimalScale={2}
                                displayType="text"
                                prefix="PHP "
                                value={_.get(formData, 'third_quarter', '') || '0'}
                              />
                            )}
                          />
                        </div>
                        <div className="">
                        <InputTemplate
                            containerClassName="mx-1"
                            // formValidatorMsg={validateForm.renderMessage("fourth_quarter")}
                            withCustomInputComponent={() => (
                              <NumberFormat
                                name="fourth_quarter"
                                id="fourth_quarter"
                                placeholder="PHP 0.00"
                                // className="full-input-v2 text-uppercase my-2"
                                className="full-input-2"
                                onValueChange={values => {
                                  const { floatValue } = values
                                  setFormData(() => ({
                                    ...formData,
                                    fourth_quarter: floatValue
                                  }));
                                }}
                                isAllowed={withValueCap}
                                isNumericString
                                thousandSeparator
                                allowNegative
                                allowLeadingZeros
                                decimalScale={2}
                                displayType="text"
                                prefix="PHP "
                                value={_.get(formData, 'fourth_quarter', '') || '0'}
                              />
                            )} 
                          />
                        </div>
                      </div>

                      {/* scroll */}
                    </div>

                </div>
              </>
             )
          }
        </div>

        {/* temporary hidden */}
        <div className="row d-none">
          {_.get(CMS_COMPONENTS, 'RPTAX_MODE_OF_PAYMENT') === true && (
            <>
              <div className="form-group col-md-6 col-lg-4 form-group-record px-2">
                <label className="form-label-v2 mb-2 form-label-v2-record">
                  Period From
                </label>
                <input
                  className="form-control form-input-record-v2"
                  id="mode_of_payment_1"
                  name="mode_of_payment_1"
                  disabled
                  value={_.get(formData, 'mode_of_payment_1')}
                />
              </div>
              <div className="form-group col-md-6 col-lg-4 form-group-record px-2">
                <label className="form-label-v2 mb-2 form-label-v2-record">
                  Period To
                </label>
                <input
                  className="form-control form-input-record-v2"
                  id="mode_of_payment_2"
                  name="mode_of_payment_2"
                  disabled
                  value={_.get(formData, 'mode_of_payment_2')}
                />
              </div>
            </>
          )}
          <div className="col-md-6 col-lg-4 form-group form-group-record px-2">
            <label className="text-color-title form-label-v2-record">Select</label>
            <div className="row-nav">
              <div className="div-overwrite">
                <div className="mr-2">
                  <input
                    name="is_overwrite"
                    type="checkbox"
                    className="check-box"
                    checked={_.get(formData, 'is_overwrite')}
                    onChange={onChange}
                  />
                </div>
                <label className="mb-0">Overwrite</label>
              </div>
              <div className="div-del">
                <div className="mr-2">
                  <input
                    name="is_delinquent"
                    type="checkbox"
                    className="check-box"
                    checked={_.get(formData, 'is_delinquent')}
                    onChange={onChange}
                  />
                </div>
                <label className="mb-0">Delinquent</label>
              </div>
            </div>
          </div>
          {_.get(CMS_COMPONENTS, 'RPTAX_AUTOMATIC_PERIOD') === true && (
            <div className="col-md-6 col-lg-4 form-group form-group-record px-2 py-3 mb-2">
              <div
                className="w-100 p-3"
                style={{
                  background: '#F2F7FF',
                  border: '1px dashed #4C6085',
                  borderRadius: '7px',
                }}
              >
                <table className="table-borderless table-sm w-100">
                  <thead>
                    <tr>
                      <th> Period From - To </th>
                      {!_.isEmpty(_.get(formData, 'date_processed')) && (
                        <th>
                          {' '}
                          {_.get(formData, 'date_processed')} -{' '}
                          {_.get(formData, 'expiration_date')}{' '}
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="py-1">1st Quarter</td>
                      <td className="py-1">
                        PHP{' '}
                        {_.get(formData, 'first_quarter')
                          ? parseFloat(
                              _.get(formData, 'first_quarter')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '0.00'}
                      </td>
                    </tr>
                    <tr>
                      <td className="py-1">2nd Quarter</td>
                      <td className="py-1">
                        PHP{' '}
                        {_.get(formData, 'second_quarter')
                          ? parseFloat(
                              _.get(formData, 'second_quarter')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '0.00'}
                      </td>
                    </tr>
                    <tr>
                      <td className="py-1">3rd Quarter</td>
                      <td className="py-1">
                        PHP{' '}
                        {_.get(formData, 'third_quarter')
                          ? parseFloat(
                              _.get(formData, 'third_quarter')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '0.00'}
                      </td>
                    </tr>
                    <tr>
                      <td className="py-1">4th Quarter</td>
                      <td className="py-1">
                        PHP{' '}
                        {_.get(formData, 'fourth_quarter')
                          ? parseFloat(
                              _.get(formData, 'fourth_quarter')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : '0.00'}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {paginateButton()}
      </form>
    </Modal.Body>
  );
}

AddRecordModalV2.defaultProps = {
  type: '',
  dataInfo: {},
  dataInclude: {},
  id: '',
};

AddRecordModalV2.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  getListManualImport: PropTypes.instanceOf(Function).isRequired,
  createRecordManualImport: PropTypes.instanceOf(Function).isRequired,
  updateRecordManualImport: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  creating: PropTypes.bool.isRequired,
  type: PropTypes.string,
  id: PropTypes.string,
  dataInfo: PropTypes.instanceOf(Object),
  dataInclude: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  creating: api.loading.indexOf(c.CREATE_RECORD_MANUAL_IMPORT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddRecordModalV2);
